import { createClient } from '@supabase/supabase-js'

// ─────────────────────────────────────────────────────────────
// KREDENSIAL SUPABASE
// Dapatkan dari: Supabase Dashboard → Settings → API
// ─────────────────────────────────────────────────────────────
const SUPABASE_URL = 'https://yrcfwfrejpzvafteucff.supabase.co'
const SUPABASE_ANON_KEY = 'sb_publishable_lKwxMayQJvJDB5NhO3W8Fw_fc2Ww-Fw'

export const isSupabaseConfigured =
  !SUPABASE_URL.includes('YOUR_PROJECT_REF') &&
  !SUPABASE_ANON_KEY.includes('YOUR_ANON_PUBLIC_KEY')

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
